var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisualIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-visual_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 248
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual_icon",
    clipPath: "url(#clip-visual_icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_217",
    "data-name": "\\uD328\\uC2A4 217",
    d: "M1181.469,215.546c-9.944-9.945-26.663-11.288-45.853-5.436.115-10.355-2.74-19.134-8.908-25.3-20.522-20.522-69.9-4.415-110.293,35.976s-56.5,89.771-35.976,110.293c9.945,9.944,26.664,11.288,45.853,5.435-.115,10.356,2.74,19.135,8.908,25.3,20.522,20.522,69.9,4.415,110.293-35.976S1201.991,236.068,1181.469,215.546Z",
    transform: "translate(-956.954 -149.311)",
    fill: "#ecdf19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_218",
    "data-name": "\\uD328\\uC2A4 218",
    d: "M1024.017,322.031c61.744,56.759,154.189,53.566,154.189,53.566",
    transform: "translate(-969.653 -184.664)",
    fill: "none",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_390",
    "data-name": "\\uADF8\\uB8F9 390",
    transform: "translate(70.526 70.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_10",
    "data-name": "\\uD0C0\\uC6D0 10",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.737,
    cy: 26.737,
    rx: 26.737,
    ry: 26.737,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.737,
    cy: 26.737,
    rx: 25.737,
    ry: 25.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_30",
    "data-name": "\\uC120 30",
    x1: 53.475,
    transform: "translate(0 26.737)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "visual_icon-2",
    "data-name": "visual_icon",
    transform: "translate(-26 -26)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "visual_icon")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualIcon);
export default __webpack_public_path__ + "static/media/visual_icon.9513cc9f2d95f728c47a036b6db559db.svg";
export { ForwardRef as ReactComponent };